module.exports = {"width":89,"height":85,"type":"png"}